module.exports = __webpack_public_path__ + "img/transport-belt.a145f08e.png";